<template>
  <section class="wrapper" id="section-3">
    <div class="flex flex-col p-3 pt-12 lg:px-12 lg:py-16 gap-8 lg:gap-16">
      <div>
        <div class="px-12 lg:p-0 font-inter font-bold text-3xl text-center lg:leading-[64px]">
          <span class="lg:mr-4">From Physical Assets to</span>
          <span class="font-inter block lg:inline gradient-word">Digital Tokens</span>
        </div>
        <div class="hidden lg:flex flex-col text-center mt-4">
          <span class="text-sm lg:text-xl">STIMA transforms real-world assets into trusted digital value.</span>
          <span
              class="text-sm lg:text-xl">From estimation to realization. The definitive Real World Asset platform</span>
        </div>
        <div class="lg:hidden px-4 text-center mt-4">
                            <span class="text-sm lg:text-xl">STIMA transforms your assets into digital tokens,
                                unlocking new possibilities for investment and portfolio management.</span>
        </div>
      </div>

      <div class="flex flex-col relative">
        <div class="w-full h-full absolute flex justify-between items-baseline p-3 lg:p-6">
          <div class="flex flex-col sm:gap-3">
            <span class="font-inter font-bold text-xl sm:text-[24px]">How STIMA Works?</span>
            <span class="font-jakarta font-regular text-sm sm:text-[16px]">3 min Explainer Video</span>
          </div>
          <span class="self-end font-jakarta font-regular text-sm sm:text-[16px]">3:24</span>
        </div>

        <div class="h lg:h-auto">
          <img class="w-full h-full rounded-xl object-cover lg:object-fill aspect-[1/1] lg:aspect-auto"
               src="/stima/assets/images/bg-banner-3-video.jpg"
               alt="Play">
          <img
              class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-500 opacity-70 hover:opacity-100 scale-90 hover:scale-100 cursor-pointer"
              src="/stima/assets/images/icons/play.svg" alt="">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Section_3',
}
</script>